export default {
  props: {
    faqCategory: {
      type: Object,
    },
    faqCategoryIcon: String,
  },
  methods: {
    scrollTo(id) {
      this.$scrollTo(`#${id}`)
      this.$router.push({ path: this.$router.path, hash: id })
    },
  },
}
